import React from 'react';
import { Dropdown, Option } from '@fluentui/react-components';

export default function FilterSelect<T>({
  value,
  onChange,
  options,
  ariaLabel,
  className,
  style,
}: {
  value: string;
  onChange: (val: string) => void;
  options: { key: string; label: string }[];
  ariaLabel?: string;
  className?: string;
  style?: React.CSSProperties;
}) {
  // Fluent UI v9 Dropdown needs an explicit `value` string for the trigger
  // button display text; `selectedOptions` alone only marks the checkmark.
  const displayValue = options.find(o => o.key === value)?.label ?? '';

  return (
    <Dropdown
      aria-label={ariaLabel}
      button={{ 'aria-label': ariaLabel }}
      appearance="outline"
      placeholder="All"
      value={displayValue}
      selectedOptions={[value]}
      onOptionSelect={(_, d) => onChange(String(d.optionValue))}
      className={className}
      style={style}
    >
      {options.map((o) => (
        <Option key={o.key} value={o.key}>
          {o.label}
        </Option>
      ))}
    </Dropdown>
  );
}
